import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import line from "../../assets/line.png";

function Busi_consulting() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <div id="sub" className="mission">
        <div className="cont-wr" >
          <div className="wr">
            <div className="cont-tit">
              <h2 className="big">컨설팅</h2>
              <div className="cont-tit">
                <h2>"최고의 솔루션으로 비즈니스 파트너로서의 역할을 수행"</h2>
              </div>
              <div className="wr">
                <p className="des">
                  고객의 NEEDS를 만족하는 최적의 솔루션으로 정보시스템 구축을
                  수행한 경험과 역량을 바탕으로
                  <br className="pc-only" />
                  고객이 GLOBAL LEADING 기업으로 나아가는데 필요한
                  <br className="pc-only" />
                  최적의 IT SOLUTION을 심도 있는 컨설팅 서비스와 함께
                  제공합니다.
                </p>
              </div>
            </div>
          </div>

          <div className="cont-wr"  >
            <div className="wr">
              <div
                className="cont-tit"
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="500"
              >
                <div className="img center">
                  <img src={line} alt="" />
                </div>
                <h2>주요 서비스</h2>
                <ul
                  className="number-box"
                  //data-aos="fade-up"
                  //data-aos-duration="700"
                >
                  <li>
                    <strong>01</strong>
                    <h3>
                      Digital Transformation
                      <br />
                      전략 컨설팅
                    </h3>
                    <p>
                      고객의 Digital Transformation 수행을 위한 전략 수립, 실행
                      등의 컨설팅 서비스를 제공합니다.
                      <br className="pc-only" />
                      디지털 변화에 대응하는 전략을 수립하고 혁신의 실행을 위한
                      디지털 과제 및 측정 가능한 효과를 산출할 수 있도록 최적의
                      방법론을 제공합니다.
                    </p>
                  </li>
                  <li>
                    <strong>02</strong>
                    <h3>
                      IT전략
                      <br /> 컨설팅
                    </h3>
                    <p>
                      기업의 경쟁력 및 경영 성과를 극대화하는 IT 전략 및 계획
                      수립을 지원합니다.
                      <br className="pc-only" /> IT 수준 진단, IT 전략 수립,
                      시스템 구현 방향 등을 제시하고, 고객 비즈니스에{" "}
                      <br className="pc-only" />
                      최적화된 IT 도입 및 운영 컨설팅 서비스를 제안합니다.
                      <br className="pc-only" />
                    </p>
                  </li>
                  <li>
                    <strong>03</strong>
                    <h3>
                      프로세스 혁신
                      <br /> 컨설팅
                    </h3>
                    <p>
                      고객 비즈니스의 성공과 기업가치의 지속적인 증대를 위한
                      업무 프로세스 혁신 컨설팅 서비스를 제공합니다.
                      <br className="pc-only" />
                      비즈니스 전략을 효과적으로 실행하기 위해 최적화된
                      프로세스를 설계하고 업무혁신을 주도하여 경영 성과를
                      향상시킬 수 있도록 지원합니다.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="cont-wr" style={{padding:'10px 0px', marginTop:'-50px'}}>
            <div className="wr">
              <div
                className="cont-tit"
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="500"
              >
                <div className="img center">
                  <img src={line} alt="" />
                </div>
                <h2>특징</h2>
                <ul className="number-box">
                  <li>
                    <strong>01</strong>
                    <h3>
                      {" "}
                      Industry
                      <br />
                      Digital Insight
                    </h3>
                    <p>
                      최고의 산업 및 Digital 전문가들이 고객의
                      <br className="pc-only" />
                      산업에 특화된 맞춤 컨설팅을 제공합니다.
                      <br className="pc-only" />
                      디지털 변화에 대응하는 전략을 수립하고 
                      <br className="pc-only" />
                      혁신의 실행을 위한 디지털 과제 및 
                      <br className="pc-only" />
                      측정가능한 효과를 산출할 수 있도록 최적의 방법론을 제공합니다.
                      <br className="pc-only" />
                    </p>
                  </li>
                  <li>
                    <strong>02</strong>
                    <h3>
                      Asset <br />
                      Based
                    </h3>
                    <p>
                      다양한 산업 기반의 프로젝트 자산, 방법론 및
                      <br className="pc-only" />
                      인사이트를 내제화하고 있습니다.
                      <br className="pc-only" />
                      다양한 컨설팅 프로젝트 경험과 산업별 변화
                      <br className="pc-only" />
                      동인, 비즈니스 모델 및 사례 분석 등의 자산을
                      <br className="pc-only" />
                      내제화하여 높은 품질의 검증된 결과를 제공합니다.
                      <br className="pc-only" />
                    </p>
                  </li>
                  <li>
                    <strong>03</strong>
                    <h3>
                      Digital Technology
                      <br /> Convergence
                    </h3>
                    <p>
                      Digital Transformation 과제의 신속한 실행을 지원합니다.
                      <br className="pc-only" />
                      컨설팅 서비스뿐만 아니라 Digital 솔루션과 미래 IT 기술을 접목하여 전략 컨설팅부터
                      <br className="pc-only" />
                      설계, 개발 및 실행까지 일관된 서비스를 제공합니다.
                      <br className="pc-only" />
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="cont-wr" style={{padding:'10px 0px'}}>
            <div className="wr">
              <div
                className="cont-tit"
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="500"
              >
                <div className="img center">
                  <img src={line} alt="" />
                </div>
                <h2>기대효과</h2>
                <ul className="number-box">
                  <li>
                    <strong>01</strong>
                    <h3>
                      {" "}
                      Improved Operational
                      <br />
                      Efficiency
                    </h3>
                    <p>
                      업무 프로세스 전 영역의 혁신을 통해 운영 효율을 획기적으로
                      증대합니다.
                      <br className="pc-only" />
                      프로세스, 조직, IT 시스템 및 의사결정 체계 전반의 Digital
                      혁신으로 원가절감, 품질 향상, 서비스 개선 등의{" "}
                      <br className="pc-only" />
                      성과를 창출하여 기업의 Digital 경쟁력을 높일 수 있습니다.
                      <br className="pc-only" />
                    </p>
                  </li>
                  <li>
                    <strong>02</strong>
                    <h3>
                      Digital Business <br />
                      Agility
                    </h3>
                    <p>
                      신기술 기반의 새로운 비즈니스 모델 및 서비스의 신속한
                      도입으로 Digital 경쟁력을 강화합니다.
                      <br className="pc-only" />
                      Digital 기반 비즈니스 모델과 서비스를 신속하게 도입할 수
                      있는 유연하고 효과적인 조직체계 및 프로세스를 조기에
                      확보할 수 있습니다.
                      <br className="pc-only" />
                    </p>
                  </li>
                  <li>
                    <strong>03</strong>
                    <h3>
                      Better Customer
                      <br /> Experience
                    </h3>
                    <p>
                      차별화된 고객 경험 제공으로 만족도와 브랜드 인지도를
                      제고하여 매출 및 고객 리텐션을 강화합니다.
                      <br className="pc-only" />
                      Digital 기반의 차별화된 서비스 개발로 보다 편리하고 업무
                      향상에 도움이 되는 경험을 느낄 수 있습니다.
                      <br className="pc-only" />
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </>
  );
}

export default Busi_consulting;
